module.exports = __webpack_public_path__ + "assets/img/brand-04.359b43aa.png";